import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

const selectSlice = createStatePropertySelector(selectSalesIntelligenceState("advancedSearch"));

export const selectCompanySearchStateSlice = selectSlice("companySearchResults");
const selectFiltersStateSlice = selectSlice("common");
export const selectContactsSearchProfilesStateSlice = selectSlice("contactsSearchProfiles");
export const selectContactsSearchStateSlice = selectSlice("contactsSearchResults");

const select = createStatePropertySelector(selectFiltersStateSlice);

/** Simple fields selectors */
export const selectSaveSearchTriggerModalOpen = select("isSaveSearchTriggerModalOpen");
export const selectSaveSearchModalPayload = select("saveSearchModal");
export const selectSearchIsDeleting = select("isSearchDeleting");
export const selectSearchDeleteError = select("searchDeleteError");
export const selectSavedSearchDeleteModalIsOpened = select("isSavedSearchDeleteModalOpened");
export const selectSavedSearchToBeDeleted = select("savedSearchToBeDeleted");
export const selectCurrentSavedSearchObject = select("currentSavedSearchObject");
export const selectExcelDownloading = select("excelDownloading");
export const selectSearchQuota = select("searchQuota");
export const selectIsSearchQuotaLoading = select("isSearchQuotaLoading");
